/* import __COLOCATED_TEMPLATE__ from './away-section.hbs'; */
/* RESPONSIBLE TEAM: team-inbox */

import Component from '@glimmer/component';
import { inject as service } from '@ember/service';
import { ref } from 'ember-ref-bucket';
import { action } from '@ember/object';
import { debounce } from '@ember/runloop';

interface Args {
  initialInactivityEnabled: boolean;
  initialInactivityThreshold: number;
  followingInactivityEnabled: boolean;
  followingInactivityThreshold: number;
  autoAwaySetting: any;
  updateTrackedProperty: (key: string, value: any) => void;
  persistAutoAwaySetting?: () => void;
}

interface Signature {
  Args: Args;
  Element: never;
}

export default class AwaySection extends Component<Signature> {
  @service declare appService: any;

  @ref('following-inactivity-threshold-input') followingInactivityThresholdInput: any;
  @ref('initial-inactivity-threshold-input') initialInactivityThresholdInput: any;

  get app() {
    return this.appService.app;
  }

  @action
  toggleInitialInactivity() {
    this.args.updateTrackedProperty(
      'initialInactivityEnabled',
      !this.args.initialInactivityEnabled,
    );
    if (this.args.persistAutoAwaySetting) {
      this.args.persistAutoAwaySetting();
    }
    if (this.args.initialInactivityEnabled) {
      this.initialInactivityThresholdInput.disabled = false;
      this.initialInactivityThresholdInput.focus();
    }
  }

  @action
  toggleFollowingInactivity() {
    this.args.updateTrackedProperty(
      'followingInactivityEnabled',
      !this.args.followingInactivityEnabled,
    );
    if (this.args.persistAutoAwaySetting) {
      this.args.persistAutoAwaySetting();
    }
    if (this.args.followingInactivityEnabled) {
      this.followingInactivityThresholdInput.disabled = false;
      this.followingInactivityThresholdInput.focus();
    }
  }

  @action
  setInitialInactivityThreshold(event: any) {
    this.args.updateTrackedProperty('initialInactivityThreshold', event.target?.value);
    if (this.args.persistAutoAwaySetting) {
      debounce(this, this.args.persistAutoAwaySetting, 500);
    }
  }

  @action
  setFollowingInactivityThreshold(event: any) {
    this.args.updateTrackedProperty('followingInactivityThreshold', event.target?.value);
    if (this.args.persistAutoAwaySetting) {
      debounce(this, this.args.persistAutoAwaySetting, 500);
    }
  }
}

declare module '@glint/environment-ember-loose/registry' {
  export default interface Registry {
    'NewSettings::Helpdesk::TabsComponents::AwaySection': typeof AwaySection;
  }
}
